<template>
  <div>
    <Head title="Добавление оборудования" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/">Добавление оборудования</Link>
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="save">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.uuid" readonly="readonly" :error="form.errors.uuid" class="pb-8 pr-6 w-full" label="Системный идентификатор" />
          <text-input v-model="form.sku" :error="form.errors.sku" :value="form.sku" class="pb-8 pr-6 w-full" label="Инвентарный номер" @focus="openSearchForm" />
          <text-input v-model="form.name" :error="form.errors.name" :value="form.name" class="pb-8 pr-6 w-full" label="Наименование" @focus="openSearchForm" />
          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="form-label" for="select-type-id">Тип оборудования:</label>
            <select id="select-type-id" v-model="form.type_id" class="form-select">
              <option disabled value=""/>
              <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
            </select>
            <div v-if="form.errors.type_id" class="form-error">{{ form.errors.type_id }}</div>
          </div>
          <select-input v-model="form.department_id" :error="form.errors.department_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Подразделение">
            <option :value="null" />
            <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.branch.name }} / {{ department.name }}</option>
          </select-input>
          <text-input v-model="form.serial" :error="form.errors.serial" class="pb-8 pr-6 w-full" label="Серийный номер" />
          <text-input v-model="form.year" :error="form.errors.year" class="pb-8 pr-6 w-full" label="Год выпуска (ДД.MM.ГГГГ)" />
          <text-input v-model="form.room" :error="form.errors.room" class="pb-8 pr-6 w-full lg:w-1/2" label="Кабинет / Помещение" />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Описание / Комментарии" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Сохранить</loading-button>
        </div>
      </form>
    </div>
  </div>
  <div id="inventorySearchModal" class="hidden relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

    <div class="fixed inset-0 z-10 w-screen">
      <div class="flex min-h-full items-end justify-center pb-4 text-center sm:items-center sm:p-0">
        <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class="relative transform rounded-lg bg-white text-left shadow-xl transition-all w-full mx-5">
          <div class="relative bg-white px-4 pb-4 pt-4">
              <div class="mt-3 mb-3 text-center w-full">
                <inventory-search v-model="searchForm.search" class="mr-4 w-full">
                  <label class="block text-gray-700">Тип оборудования:</label>
                  <select v-model="searchForm.type" class="form-select mt-1 w-full">
                    <option :value="null" />
                    <option value="10">Медицинское</option>
                    <option value="20">Компьютерное</option>
                    <option value="30">Мебель</option>
                  </select>
                </inventory-search>
              </div>
            <div class="relative mt-3 mb-3 text-center w-full overflow-y-auto overflow-x-hidden" style="height: 70vh">
              <table class="w-full">
                <thead>
                <tr class="text-left font-bold">
                  <th class="pb-4 pt-6 pr-4 text-left">Инв.№</th>
                  <th class="pb-4 pt-6 text-left">Наименование</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="inventory in inventories" :key="inventory.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                  <td class="border-t text-left">
                    <div class="flex items-center pr-4 py-2" @click="applyInventory(inventory.sku, inventory.name, inventory.type_id)" tabindex="-1">
                      {{ inventory.sku }}
                    </div>
                  </td>
                  <td class="border-t text-left">
                    <div class="flex items-start py-2" @click="applyInventory(inventory.sku, inventory.name, inventory.type_id)" tabindex="-1">
                      {{ inventory.name }}
                    </div>
                  </td>
                </tr>
                <tr v-if="inventories.length === 0">
                  <td class="px-6 py-4 border-t" colspan="4">ничего не найдено</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button type="button" @click="closeSearchForm" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from "@/Shared/TextareaInput.vue";
import InventorySearch from "@/Shared/InventorySearch.vue";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

export default {
  components: {
    InventorySearch,
    TextareaInput,
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    uuid: String,
    departments: Array,
    types: Array,
    inventories: Array,
    filters: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        uuid: this.uuid,
        sku: '',
        name: '',
        room: '',
        department_id: '',
        description: '',
        serial: '',
        year: '',
        type_id: '',
      }),
      searchForm: {
        filters: Object,
      }
    }
  },
  watch: {
    searchForm: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('', pickBy(this.searchForm), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    save() {
      this.form.post(`/inventories`)
    },
    openSearchForm() {
      document.getElementById('inventorySearchModal').classList.remove('hidden');
      document.addEventListener( "keydown", this.onKeydown );
    },
    closeSearchForm() {
      document.getElementById('inventorySearchModal').classList.add('hidden');
      document.removeEventListener( "keydown", this.onKeydown );
    },
    applyInventory(sku, name, type_id) {
      this.form.sku = sku;
      this.form.name = name;
      this.form.type_id = type_id;
      document.getElementById('inventorySearchModal').classList.add('hidden');
    },
    onKeydown( event ) {
      if(event.key === "Escape"){
        this.closeSearchForm();
      }
    },
  },
}
</script>
